import React, { useState, useEffect } from "react";
import { Col, Row } from "reactstrap";
import {
  message,
  Input,
  Button,
  Form,
  Space,
  Tooltip,
  Drawer,
  Card,
  Checkbox,
  Select,
  Modal,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleFilled,
} from "@ant-design/icons";
import moment from "moment";
import { Trans, useTranslation } from "react-i18next";
import {
  deleteRole,
  getPagingRole,
  insertRole,
  updateRole,
  deleteManyRole,
  GetRoleManagementPage,
} from "../../../helpers/helper";
import DataTable from "../../../Components/Common/DataTable";
import { actionGroup } from "../../../helpers/common";

const { Option } = Select;
const { confirm } = Modal;
const Roles = () => {
  const { t } = useTranslation();
  document.title = t("role");

  const [form] = Form.useForm();
  const [formSearch] = Form.useForm();
  const [listRole, setListRole] = useState([]);
  const [listAllRole, setListAllRole] = useState([]);
  const [visibleForm, setVisibleForm] = useState(false);
  const [drawerTitle, setDrawerTitle] = useState("");

  // Action
  const [listAction, setListAction] = useState([]);
  const [checkedList, setCheckedList] = useState([]);
  const [checkAll, setCheckAll] = useState(false);

  //pagination
  const [totalPage, setTotalPage] = useState(1);
  const [indexPage, setPageIndex] = useState(1);
  const [loading, setLoading] = useState(true);
  const [pageSize, setPageSize] = useState(10);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loadingDeleteRows, setLoadingDeleteRows] = useState(false);
  const [itemRole, setItemRole] = useState();

  const actionDecides = [
    { name: "getPagingActions", group: "action" },
    { name: "getActionHistoryManagementPage", group: "actionHistory" },
    { name: "getApplicationManagementPage", group: "application" },
    { name: "getCompanyManagementPage", group: "company" },
    { name: "getDepartmentManagementPage", group: "department" },
    { name: "getGroupManagementPage", group: "group" },
    { name: "getPagingHistories", group: "history" },
    { name: "getRoleManagementPage", group: "role" },
    { name: "getShiftManagementPage", group: "shift" },
    { name: "getUserManagementPage", group: "user" },
    { name: "Dashboard", group: "dashboard" },
  ];

  const getAllData = async (_prams, indexPage) => {
    try {
      const params = _prams
        ? _prams
        : {
            pageIndex: indexPage,
            pageSize: pageSize,
            search: "",
          };
      const dataRes = await getPagingRole(params);
      setTotalPage(dataRes?.totalPages);
      let data = convertDataTable(dataRes.data);

      return data.length ? data : false;
    } catch (error) {
      setTotalPage(0);
      message.error(t("requiredPermission"));
      return [];
    }
  };

  const convertDataTable = (dataArray) => {
    let data =
      dataArray.length > 0 &&
      dataArray.map((item) => {
        return {
          key: item._id,
          roleName: item.roleName,
          actions: item.actions,
          createdTime: moment(new Date(item.createdTime)).format("DD/MM/YYYY"),
        };
      });
    data = data ? data.filter((item) => item.roleName !== "SuperAdmin") : false;
    return dataArray ? data : [];
  };

  useEffect(() => {
    setLoading(true);
    async function fetchData() {
      try {
        const data = await GetRoleManagementPage();

        setTotalPage(data.dataPage?.totalPages);
        const dataShowTable = convertDataTable(data.dataPage?.data);
        setListRole(dataShowTable);

        const listAction = data.actions
          ?.sort((a, b) => a.actionName.localeCompare(b.actionName))
          .map((item) => {
            return item;
          });
        setListAction(listAction);

        let listAllRole = data.roles
          ? data.roles?.map((item) => {
              return {
                _id: item._id,
                roleName: item.roleName,
              };
            })
          : [];
        listAllRole = listAllRole.filter(
          (item) => item.roleName !== "SuperAdmin"
        );
        setListAllRole(listAllRole);
        setLoading(false);
      } catch (error) {
        message.error(t("requiredPermission"));
        setListRole([]);
        setLoading(false);
        setListAction([]);
        setListAllRole([]);
      }
    }
    fetchData();
  }, [indexPage]);

  const onFinish = async (data) => {
    try {
      if (data.roleName) {
        data.roleName = data.roleName.trim();
      }

      checkedList.findIndex((x) => x.actionName === "getAllActions") < 0 &&
        checkedList.push("getAllActions");
      const actionIdList = listAction
        .filter((action) => checkedList.includes(action.actionName))
        .map((action) => action._id);

      const dataReq = {
        roleName: data.roleName,
        actions: actionIdList,
      };
      if (!data.id) {
        const dataRes = await insertRole(dataReq);
        if (dataRes.status === 1) {
          message.success(t("saveSuccess"));
        } else if (dataRes.status === 0) {
          message.error(t("roleNameAlreadyExists"));
        } else {
          message.error(t("saveFail"));
        }
        formSearch.resetFields();
        handleRefresh();
      } else {
        const role = listRole.find((role) => role.key === data.id);
        const roleOrigin = role.actions.map((item) => item._id);
        const equalArray =
          JSON.stringify(roleOrigin) === JSON.stringify(actionIdList);
        if (data.roleName === role.roleName && equalArray) {
          message.success(t("dataNotChange"));
          handleCloseDrawer();
        } else {
          const dataRes = await updateRole(data.id, dataReq);
          if (dataRes.status === 1) {
            message.success(t("updateSuccess"));
          } else if (dataRes.status === 0) {
            message.error(t("roleNameAlreadyExists"));
          } else {
            message.error(t("updateFail"));
          }
          handleRefreshData();
        }
      }
      form.resetFields();
      handleCloseDrawer();
    } catch (error) {
      message.error(t("permisstionDeniedAction"));
      formSearch.resetFields();
      form.resetFields();
      handleCloseDrawer();
    }
  };

  const handleRefresh = async () => {
    const _params = {
      pageIndex: 1,
      pageSize: 10,
      search: "",
    };
    const dataRes = await getAllData(_params, indexPage);
    setListRole(dataRes.length > 0 ? dataRes : listRole);
    setPageIndex(1);
    formSearch.resetFields();
  };

  const handleSearch = async () => {
    const dataForm = formSearch.getFieldsValue();
    if (!Object.values(dataForm).some((item) => !!item)) {
      return;
    }
    const params = {
      pageIndex: 1,
      pageSize: pageSize,
      search: dataForm.roleName || "",
    };
    const dataRes = await getAllData(params, 1);
    setListRole(dataRes.length > 0 ? dataRes : false);
    setPageIndex(1);
  };

  const onPageChange = (page, page_size) => {
    setPageIndex(page);
    setPageSize(page_size);
    onPageChangeAtSearch(page, page_size);
  };

  const onPageChangeAtSearch = async (indexPage, page_size) => {
    setLoading(true);
    const dataForm = formSearch.getFieldsValue();
    const params = {
      pageIndex: indexPage,
      pageSize: page_size,
      search: dataForm.roleName || "",
    };
    const dataRes = await getAllData(params, indexPage);
    setListRole(dataRes.length > 0 ? dataRes : false);
    setLoading(false);
  };

  const onEdit = (key) => {
    const dataEdit = listRole.filter((item) => item.key === key);
    setItemRole(dataEdit[0]);

    form.setFieldsValue({
      roleName: dataEdit[0].roleName,
      id: dataEdit[0].key,
    });
    let actionList = dataEdit[0]?.actions?.map((action) => action.actionName);
    setCheckedList(actionList);
    setCheckAll(actionList.length === listAction.length);
    setDrawerTitle(t("editRole"));
    showDrawer();
  };

  const handleRefreshData = async (index_page) => {
    const dataForm = formSearch.getFieldsValue();
    const _params = {
      pageIndex: index_page ? index_page : indexPage,
      pageSize: pageSize,
      search: dataForm.roleName || "",
    };
    const dataRes = await getAllData(_params);
    setListRole(dataRes);
    setPageIndex(index_page ? index_page : indexPage);
  };

  const handleRefreshDataDelete = async (countRemove) => {
    const indexPageNew =
      listRole.length == countRemove
        ? indexPage === 1
          ? 1
          : indexPage - 1
        : indexPage;
    handleRefreshData(indexPageNew);
  };

  const onDelete = async (key) => {
    try {
      const dataRes = await deleteRole(key);
      if (dataRes.status === 1) {
        message.success(t("deleteSuccess"));
        handleRefreshDataDelete(1);
      } else {
        message.error(t("deleteFail"));
      }
    } catch (error) {
      message.error(t("permisstionDeniedAction"));
    }
  };

  const showModalConfirmDelete = (record) => {
    confirm({
      title: t("confirmDelete"),
      icon: <ExclamationCircleFilled />,
      okText: t("delete"),
      okType: "danger",
      cancelText: t("cancel"),
      onOk() {
        onDelete(record);
      },
      onCancel() {},
    });
  };

  const validateInput = (_, value) => {
    if (!value || value.trim() === "") {
      return Promise.reject();
    }
    return Promise.resolve();
  };

  const columns = [
    {
      title: t("roleName"),
      dataIndex: "roleName",
    },
    {
      title: t("userAction"),
      dataIndex: "",
      width: "50%",
      render: (_, record) => {
        return (
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
            }}
          >
            {actionGroup.map((item) => {
              if (filterByActionGroup(item.value, record.actions).length > 0)
                return (
                  <div
                    key={item.value}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "50%",
                    }}
                  >
                    <p style={{ marginTop: "15px", marginBottom: 0 }}>
                      {item.label} :
                    </p>
                    {filterByActionGroup(item.value, record.actions).map(
                      (action) => {
                        return (
                          <p style={{ margin: 0 }} key={action.actionName}>
                            {` - ${action.actionLabel}`}
                          </p>
                        );
                      }
                    )}
                  </div>
                );
            })}
          </div>
        );
      },
    },
    {
      title: t("createdTime"),
      dataIndex: "createdTime",
    },
    {
      title: t("action"),
      dataIndex: "",
      render: (_, record) =>
        listRole.length >= 1 ? (
          <Space>
            <Tooltip title={t("edit")}>
              <Button
                type="primary"
                shape="circle"
                icon={<EditOutlined />}
                size="small"
                onClick={() => onEdit(record.key)}
              />
            </Tooltip>
            <Tooltip title={t("delete")}>
              <Button
                type="danger"
                shape="circle"
                icon={<DeleteOutlined />}
                size="small"
                onClick={() => showModalConfirmDelete(record.key)}
              />
            </Tooltip>
          </Space>
        ) : null,
    },
  ];

  const onClose = () => {
    setVisibleForm(false);
  };

  const showDrawer = () => {
    setVisibleForm(true);
  };

  const handleNewRole = () => {
    setDrawerTitle(t("createRole"));
    showDrawer();
    form.resetFields();
    setCheckedList([]);
    setCheckAll(false);
  };

  const handleCloseDrawer = () => {
    setDrawerTitle("");
    setVisibleForm(false);
    form.resetFields();
  };

  const onCheckAllActionsChange = (e) => {
    const _listAction = listAction?.map((item) => {
      return item.actionName;
    });
    setCheckedList(e.target.checked ? _listAction : []);
    setCheckAll(e.target.checked);
  };

  const checkShowActionDecide = (action_name, action_group, list) => {
    if (!list.includes(action_name)) {
      let item = listAction.filter((item) => item.actionGroup === action_group);
      let data = [];
      item.map((value) => {
        data.push(value.actionName);
      });
      data.map((value) => {
        if (list.includes(value)) {
          list.splice(list.indexOf(value), 1);
        }
      });
    }
    return list;
  };

  const onChangeActionsUser = (list) => {
    setCheckedList(list);
    setCheckAll(list.length === listAction.length);
  };

  const onChangeActions = (list) => {
    if (list.length >= checkedList.length) {
      let actionName = list[list.length - 1];
      let item = listAction.filter((item) => item.actionName === actionName);
      if (
        !actionDecides.includes({
          name: item[0].actionName,
          group: item[0].actionGroup,
        })
      ) {
        let template = actionDecides.find(
          (value) => value.group === item[0].actionGroup
        );
        if (template && !list.includes(template.name)) {
          list.push(template.name);
        }
      }
    }

    list = checkShowActionDecide("getPagingActions", "action", list);
    list = checkShowActionDecide(
      "getActionHistoryManagementPage",
      "actionHistory",
      list
    );
    list = checkShowActionDecide(
      "getApplicationManagementPage",
      "application",
      list
    );
    list = checkShowActionDecide("getCompanyManagementPage", "company", list);
    list = checkShowActionDecide(
      "getDepartmentManagementPage",
      "department",
      list
    );
    list = checkShowActionDecide("getGroupManagementPage", "group", list);
    list = checkShowActionDecide("getPagingHistories", "history", list);
    list = checkShowActionDecide("getRoleManagementPage", "role", list);
    list = checkShowActionDecide("getShiftManagementPage", "shift", list);
    list = checkShowActionDecide("getUserManagementPage", "user", list);
    list = checkShowActionDecide("Dashboad", "Dashboard", list);

    setCheckedList(list);
    setCheckAll(list.length === listAction.length);
  };

  const filterByActionGroup = (actionGroup, data) => {
    if (data && data.length > 0) {
      return data.filter((item) => item.actionGroup === actionGroup);
    } else return [];
  };

  const handleDeleteSelectRows = async () => {
    confirm({
      title: (
        <Trans
          i18nKey="confirmDeleteManyRole"
          values={{ count: selectedRowKeys.length }}
        />
      ),
      icon: <ExclamationCircleFilled />,
      okText: t("delete"),
      okType: "danger",
      cancelText: t("cancel"),
      onOk() {
        OnDeleteSelectRows();
      },
      onCancel() {},
    });
  };

  const OnDeleteSelectRows = async () => {
    try {
      setLoadingDeleteRows(true);

      const dataRes = await deleteManyRole({ data: { ids: selectedRowKeys } });

      if (dataRes.status === 1) {
        message.success(
          <Trans
            i18nKey="deleteManyRoleSuccess"
            values={{ count: dataRes.data.deletedCount }}
          />
        );
        handleRefreshDataDelete(dataRes.data.deletedCount);
      } else {
        message.error(t("deleteFail"));
      }
      setSelectedRowKeys([]);
      setLoadingDeleteRows(false);
    } catch (error) {
      setLoadingDeleteRows(false);
      message.error(t("permisstionDeniedAction"));
    }
  };
  return (
    <>
      <div className="page-content">
        <Card bordered={false}>
          <Row>
            <Col xs={12}>
              <Form
                form={formSearch}
                layout="vertical"
                onFinish={onFinish}
                autoComplete="off"
              >
                <Row>
                  <Col hidden={true}>
                    <Form.Item name="id" label="Id">
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col sm={3}>
                    <Form.Item name="roleName" label={t("roleName") + ":"}>
                      <Select
                        placeholder={t("placeHolderSelectRole")}
                        allowClear
                        showSearch
                        onChange={() => handleSearch()}
                      >
                        {listAllRole.length > 0 &&
                          listAllRole.map((item) => {
                            return (
                              <Option key={item._id} value={item.roleName}>
                                {item.roleName}
                              </Option>
                            );
                          })}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col sm={3}>
                    <Form.Item className="mt-4">
                      <Space>
                        <Button
                          type="primary"
                          htmlType="button"
                          onClick={() => handleSearch()}
                        >
                          {t("search")}
                        </Button>

                        <Button type="primary" onClick={handleNewRole}>
                          {t("createRole")}
                        </Button>

                        <Button
                          type="primary"
                          htmlType="button"
                          onClick={() => handleRefresh()}
                        >
                          {t("reload")}
                        </Button>
                        <Button
                          disabled={selectedRowKeys.length == 0}
                          loading={loadingDeleteRows}
                          type="danger"
                          htmlType="button"
                          onClick={() => handleDeleteSelectRows()}
                        >
                          {t("delete")}
                        </Button>
                      </Space>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Card>
        <div>
          <Col>
            <Drawer
              title={drawerTitle}
              placement={"right"}
              width="50%"
              onClose={onClose}
              open={visibleForm}
              bodyStyle={{
                paddingBottom: 80,
              }}
              style={{ marginTop: "70px" }}
            >
              <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                autoComplete="off"
              >
                <Row>
                  <Col hidden={true}>
                    <Form.Item name="id" label="Id">
                      <Input />
                    </Form.Item>
                  </Col>
                  <Form.Item
                    name="roleName"
                    label={t("roleName")}
                    rules={[
                      {
                        required: true,
                        validator: validateInput,
                        message: t("validateRoleName"),
                      },
                      {
                        type: "string",
                        min: 1,
                      },
                    ]}
                  >
                    <Input
                      placeholder={t("placeHolderSelectRole")}
                      allowClear={true}
                    />
                  </Form.Item>
                  <Form.Item name="actions" label={t("action")}>
                    <Space
                      direction="vertical"
                      size="middle"
                      style={{ display: "flex" }}
                    >
                      <Checkbox
                        onChange={onCheckAllActionsChange}
                        checked={checkAll}
                      >
                        {t("selectAll")}
                      </Checkbox>
                      <Checkbox.Group
                        value={checkedList}
                        onChange={
                          itemRole?.roleName === "user"
                            ? onChangeActionsUser
                            : onChangeActions
                        }
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                        }}
                      >
                        {actionGroup.map((item) => {
                          return (
                            <div
                              key={item.value}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "50%",
                              }}
                            >
                              <p style={{ marginTop: "15px" }}>
                                {item.label} :
                              </p>
                              {filterByActionGroup(item.value, listAction).map(
                                (action) => {
                                  return (
                                    action.actionName !== "getAllActions" && (
                                      <Checkbox
                                        style={{ margin: 0 }}
                                        key={action.actionName}
                                        value={action.actionName}
                                      >
                                        {action.actionLabel}
                                      </Checkbox>
                                    )
                                  );
                                }
                              )}
                            </div>
                          );
                        })}
                      </Checkbox.Group>
                    </Space>
                  </Form.Item>
                </Row>

                <Form.Item className="mt-3">
                  <Space>
                    <Button type="primary" htmlType="submit">
                      {t("save")}
                    </Button>

                    <Button type="danger" onClick={handleCloseDrawer}>
                      {t("close")}
                    </Button>
                  </Space>
                </Form.Item>
              </Form>
            </Drawer>
          </Col>
        </div>
        <DataTable
          listData={listRole}
          pageSize={pageSize}
          columns={columns}
          indexPage={indexPage}
          totalPage={totalPage}
          onPageChange={onPageChange}
          loading={loading}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
        />
      </div>
    </>
  );
};
export default Roles;
